export default __webpack_public_path__ + "static/media/Bloodseraph's Chestguard.3c691c8a.jpg";